import { render, staticRenderFns } from "./TreatmentIndex.vue?vue&type=template&id=aaad0778&"
import script from "./TreatmentIndex.vue?vue&type=script&lang=js&"
export * from "./TreatmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports